import { render } from "./H5Details.vue?vue&type=template&id=a5fee1ca"
import script from "./H5Details.vue?vue&type=script&lang=js"
export * from "./H5Details.vue?vue&type=script&lang=js"

import "./H5Details.vue?vue&type=style&index=0&id=a5fee1ca&scope=true&lang=css"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__